var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 33,
    viewBox: "0 0 32 33",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OlyBet/Icon/dashboard-alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 14.769V5.70234C29.3333 3.70234 28.48 2.90234 26.36 2.90234H20.9733C18.8533 2.90234 18 3.70234 18 5.70234V14.769C18 16.769 18.8533 17.569 20.9733 17.569H26.36C28.48 17.569 29.3333 16.769 29.3333 14.769Z",
    id: "Vector",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 26.7703V24.3703C29.3333 22.3703 28.48 21.5703 26.36 21.5703H20.9733C18.8533 21.5703 18 22.3703 18 24.3703V26.7703C18 28.7703 18.8533 29.5703 20.9733 29.5703H26.36C28.48 29.5703 29.3333 28.7703 29.3333 26.7703Z",
    id: "Vector_2",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 17.7023V26.769C14.0013 28.769 13.148 29.569 11.028 29.569H5.6413C3.5213 29.569 2.66797 28.769 2.66797 26.769V17.7023C2.66797 15.7023 3.5213 14.9023 5.6413 14.9023H11.028C13.148 14.9023 14.0013 15.7023 14.0013 17.7023Z",
    id: "Vector_3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 5.70234V8.10234C14.0013 10.1023 13.148 10.9023 11.028 10.9023H5.6413C3.5213 10.9023 2.66797 10.1023 2.66797 8.10234V5.70234C2.66797 3.70234 3.5213 2.90234 5.6413 2.90234H11.028C13.148 2.90234 14.0013 3.70234 14.0013 5.70234Z",
    id: "Vector_4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.3ba6e3a58b6e789a1bdc844d45da47db.svg";
export { ForwardRef as ReactComponent };